/**
 * GoalFormModal — wraps the shared FormModal with the goal field
 * schema. `risk_ids` multi-select pulls from the Step 6 risk list
 * (injected at render time by the consumer).
 */
import React, { useMemo } from 'react';
import FormModal from '../../../../components/ui/FormModal/FormModal';
import { GOAL_FORM_FIELDS, type GoalRecord } from './goalsFieldSchema';

const FormModalAny = FormModal as unknown as React.ComponentType<any>;

export interface OptionLite {
  value: string;
  label: string;
}

export interface GoalFormModalProps {
  mode: 'add' | 'edit';
  initialGoal?: GoalRecord | null;
  riskOptions: OptionLite[];
  onSubmit: (values: Record<string, unknown>) => Promise<void>;
  onClose: () => void;
}

export default function GoalFormModal({
  mode,
  initialGoal,
  riskOptions,
  onSubmit,
  onClose,
}: GoalFormModalProps) {
  const isEdit = mode === 'edit';

  const fields = useMemo(
    () =>
      GOAL_FORM_FIELDS.map((f) => {
        if (f.name === 'risk_ids') return { ...f, options: riskOptions };
        if (isEdit && f.name === 'goal_id') return { ...f, disabled: true };
        return f;
      }),
    [riskOptions, isEdit],
  );

  return (
    <FormModalAny
      title={isEdit ? 'Edit Cybersecurity Goal' : 'Add Cybersecurity Goal'}
      fields={fields}
      initialValues={initialGoal ?? {}}
      submitLabel={isEdit ? 'Save Changes' : 'Add Goal'}
      submittingLabel={isEdit ? 'Saving…' : 'Adding…'}
      onSubmit={onSubmit}
      onClose={onClose}
      maxWidth={720}
    />
  );
}
